import { Box, Typography } from '@mui/material'
import AccountStyle from 'layouts/dashboard/styles/accountStyles'
import palette, { PRIMARY } from 'theme/palette'

export const AccountExpanded = ({ user }) => {
  return (
    <>
      <AccountStyle
        sx={{
          m: 2.4,
          /*@ts-ignore*/
          bgcolor: window?.brand === 'nab' ? '#c20000' : palette.light.primary.newBg,
          fontFamily: 'Inter',
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '24px',
          borderRadius: '4px'
        }}
      >
        <Box>
          <Typography
            variant="statusbarLabel"
            sx={{ color: '#000000', fontWeight: 'bold', fontSize: '20px' }}
          >
            {user?.nameLabelDisplay}
            <br />
          </Typography>
          <Typography variant="body2" sx={{ color: '#000000' }}>
            {user?.orgLabelDisplay}
          </Typography>
        </Box>
      </AccountStyle>
    </>
  )
}

export default AccountExpanded
